import { connect, FormikValues } from 'formik'
import { IntlShape, useIntl } from 'react-intl'
import styled from 'styled-components'
import { string } from 'yup'

import FilterSelect from '@/components/Form/FilterSelect'
import Label from '@/components/Label'
import { Row } from '@/components/StyledComponents'
import useFeatures from '@/components/useFeatures'
import { WORKSHOP_AGENTS } from '@/constants/featureToggles'
import { DeployFeatureStepData, StepData } from '@/pages/SpaceAppBuilder/utilities/interfaces'

import messages from './messages'

//<editor-fold desc="Styled Components">
const StyledRow = styled(Row)`
  justify-content: flex-start;
  margin-bottom: 5px;
`
const StyledSection = styled.div`
  margin-bottom: 20px;
`
const StyledFilterSelect = styled(FilterSelect)`
  .ui.selection.dropdown .menu > .item {
    padding: 0.5rem 1rem !important;
  }
`
const OptionLabel = styled.label`
  font-size: 14px;
  font-weight: normal;
  color: #3a3a3a;
`
const Description = styled.p`
  margin-top: 2px;
  margin-bottom: 5px;
  margin-right: 5px;
  font-size: 0.8rem;
  word-break: break-word;
  white-space: normal;
  color: #6c6c6c;
`
//</editor-fold>

//<editor-fold desc="Interfaces">
type DeployFeatureProps = {
  readOnly?: boolean
}
//</editor-fold>

const getValidationSchema = (intl: IntlShape) => {
  return {
    mode: string().required(intl.formatMessage(messages.deployFeatureModeRequired))
  }
}

const getInitialValues = (stepData: DeployFeatureStepData): StepData => {
  return {
    mode: stepData.mode
  }
}

const DeployFeatureOperation = ({ readOnly = false }: DeployFeatureProps & FormikValues) => {
  const intl = useIntl()
  const features = useFeatures()
  const agentsFlagOn = !!features[WORKSHOP_AGENTS]
  const getMode = (intl: IntlShape) => [
    {
      text: agentsFlagOn ? intl.formatMessage(messages.deployCapability) : intl.formatMessage(messages.deployFeature),
      description: `Deploys only the current ${agentsFlagOn ? 'capability' : 'feature'}`,
      value: 'deployFeature'
    },
    {
      text: intl.formatMessage(messages.deployApp),
      description: `Deploys all ${agentsFlagOn ? 'capabilities' : 'features'} within this app`,
      value: 'deployApp'
    }
  ]

  const getModeOptions = (intl: IntlShape) => {
    return getMode(intl).map((mode: any) => ({
      key: mode.text,
      text: mode.text,
      value: mode?.value,
      content: (
        <div>
          <OptionLabel>{mode.text}</OptionLabel>
          <Description>{mode.description}</Description>
        </div>
      )
    }))
  }

  return (
    <StyledSection>
      <StyledRow>
        <Label required>{intl.formatMessage(messages.deployType)}</Label>
      </StyledRow>
      <StyledFilterSelect
        onBlur={() => {}}
        disabled={readOnly}
        name={`stepData.mode`}
        placeholder={intl.formatMessage(messages.deployFeatureSelectType)}
        options={getModeOptions(intl)}
        selection={true}
        showValidationMessage={true}
        required
        className="fill-space"
      />
    </StyledSection>
  )
}

export default connect(DeployFeatureOperation)

export { getInitialValues, getValidationSchema }
